import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  submitButton: {
    id: 'containers.settings.submitButton',
    defaultMessage: 'Save',
  },
  validationRequiredField: {
    id: 'containers.settings.validation.required.field',
    defaultMessage: 'Field value required',
  },
  placeholderFirstName: {
    id: 'containers.settings.form.placeholder.firstName',
    defaultMessage: 'First Name',
  },
  placeholderLastName: {
    id: 'containers.settings.form.placeholder.lastName',
    defaultMessage: 'Last Name',
  },
  placeholderPostcode: {
    id: 'containers.settings.form.placeholder.postcode',
    defaultMessage: 'Postcode',
  },
  placeholderCountry: {
    id: 'containers.settings.form.placeholder.country',
    defaultMessage: 'Country',
  },
  placeholderAddress: {
    id: 'containers.settings.form.placeholder.address',
    defaultMessage: 'Address',
  },
  placeholderMinSum: {
    id: 'containers.settings.form.placeholder.minSum',
    defaultMessage: 'Minimum payment',
  },
  placeholderCompany: {
    id: 'containers.settings.form.placeholder.company',
    defaultMessage: 'Company',
  },
  successText: {
    id: 'containers.settings.form.successText',
    defaultMessage: 'Saved successfully!',
  },
});



// WEBPACK FOOTER //
// ./src/containers/Settings/messages.js